//所有全局插件

import axios from 'axios';
import store from '../store/index';
import router from '../router/index';
import tools from './tools';
import md5 from 'blueimp-md5';
import JSEncrypt from "jsencrypt"; 
import globalConfig from './globalConfig'

/************** axios 拦截器  ***************/
// http request 拦截器
// axios.defaults.timeout = 0;
// axios.interceptors.request.use(
//   config => {
//     // if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
//     //   config.headers.Authorization = `token ${store.state.token}`;
//     // }
//     console.log('request from interceptors');
//     return config;
//   },
//   err => {
//     return Promise.reject(err);
//   });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log('response from interceptors：', response);
    if(response.data.code == 200){
      let user = tools.getLocalStorage('IP360', 'user');
      if(user){
        user.timestamp = Date.now();
        let Truthso = {
          user: user
        };
        tools.setLocalStorage('IP360', Truthso);
        store.commit('login', user);
      };
      return response;

    }else if(response.data.code == 102 || response.data.code == 103){
      //判断用户请求结果，是否为token无效或其它 token相关问题，如果是，则转入登陆页
      // console.log('response 102 or 103 in plugin: ', response.data.message);
      store.commit('logout');
      localStorage.removeItem('IP360');
      router.replace({
        path: '/',
        query: {
          redirect: router.currentRoute.fullPath,
          action: 'login'
        }
      })
    }else{
      return response;
    }

  },
  error => {
    // console.log('error from interceptors：', error);
    // let response = {
    //   code: 80001,
    //
    // }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  });

/************** axios 拦截器 end  ***************/

let ToolsPlugin = {
  install: function(Vue, options){
    // Vue.QueryUrlParams = function (url) {
    //   var match,
    //     pl     = /\+/g,  // Regex for replacing addition symbol with a space
    //     search = /([^&=]+)=?([^&]*)/g,
    //     decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
    //     query  = url? url.substring(url.lastIndexOf("?")+1) : window.location.search.substring(1);
    //
    //   var urlParams = {};
    //   while (match = search.exec(query))
    //     urlParams[decode(match[1])] = decode(match[2]);
    //   return urlParams;
    // };

    Vue.prototype.$globalConfig = globalConfig;

    Vue.prototype.$queryUrlParams = function (url) {
      var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = url? url.substring(url.lastIndexOf("?")+1) : window.location.search.substring(1);

      var urlParams = {};
      while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
      return urlParams;
    }

    //从localStorage中获取数据
    // 若prop为空，则只取健为 key 的storage数据，
    // 若prop不为空，则根据 key 取出数据后，再去取该prop的值，如果取不到，返回null
    Vue.prototype.$getLocalStorage = function(key, prop){
      let item = localStorage.getItem(key);
      if(item){
        item = JSON.parse(item);
        if(key){
          if(item[prop]){
            item = item[prop];
          }else{
            item = null;
          }
        }
      } else {
        item = null;
      }

      return item;
    };

    Vue.prototype.$setLocalStorage = function(key, data){
      if(key && data){
        localStorage.setItem(key, JSON.stringify(data));
      }
    };

    Vue.prototype.$cutString = function (originalStr, limit, withEllipsis){
      let length = lengthCalc(originalStr);
      if(length <= limit){
        return originalStr;
      }

      if(withEllipsis){
        limit = limit -3;
      }

      if(!limit || limit <=0){
        return originalStr;
      }

      let newStr = '';
      let len = originalStr.length, charCode = -1;
      for (let i = 0; i < len; i++) {
        charCode = originalStr.charCodeAt(i);
        // console.log(`char code is ${charCode}`);
        // console.log(`index is ${i}`);
        if (charCode >= 0 && charCode <= 128){
          if(lengthCalc(newStr) + 1 <= limit){
            newStr += String.fromCharCode(charCode);
          }else{
            break;
          }
        }else{
          if(lengthCalc(newStr) + 2 <= limit){
            newStr += String.fromCharCode(charCode);
          }else{
            break;
          }
        }
        // console.log('new string: ', newStr);
      }

      if(withEllipsis){
        newStr += "...";
      }

      return newStr;

      function lengthCalc(str){
        let len = 0;
        for (let i = 0; i < str.length; i++) {
          charCode = str.charCodeAt(i);
          if (charCode >= 0 && charCode <= 128){
            len += 1;
          }else{
            len +=2
          }
        }

        return len;
      }

    };

    Vue.prototype.$lengthCalc = function (str){
      let len = 0, charCode = -1;
      for (let i = 0; i < str.length; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128){
          len += 1;
        }else{
          len +=2
        }
      }
      return len;
    };

    Vue.prototype.$axios = axios;

    Vue.prototype.$md5 = md5;

    //RSA加密（公钥）
    Vue.prototype.$jsEncrypt = JSEncrypt;
    //浏览器是否支持placeholder
    Vue.prototype.$isPlaceholder = function () {
      let input = document.createElement('input');
      return "placeholder" in input;
    }

    Vue.prototype.$setFrameHeight = function(status) {
      document.getElementsByTagName('html')[0].style.height = status;
      document.getElementsByTagName('body')[0].style.height = status;
    };

    Vue.prototype.$getRouterQuery = function(query,changeQuery){
      if(!changeQuery){changeQuery={}};
      let newQuery = {};
      for(let i in query){
        newQuery[i] = query[i];
      }
      for(let j in changeQuery){
        newQuery[j] = changeQuery[j]
      }
      return newQuery;
    };
  }
}

export {ToolsPlugin}



// WEBPACK FOOTER //
// ./src/lib/plugins.js